export const enum CADESCOM_STORE_LOCATION {
    CADESCOM_MEMORY_STORE = 0,
    CADESCOM_LOCAL_MACHINE_STORE = 1,
    CADESCOM_CURRENT_USER_STORE = 2,
    CADESCOM_ACTIVE_DIRECTORY_USER_STORE = 3,
    CADESCOM_SMART_CARD_USER_STORE = 4,
    CADESCOM_CONTAINER_STORE = 100
}

export const enum CADESCOM_CADES_TYPE {
    CADESCOM_CADES_BES = 1,
    CADESCOM_CADES_DEFAULT = 0,
    CADESCOM_CADES_T = 5,
    CADESCOM_CADES_X_LONG_TYPE_1 = 93,
}

export const enum CADESCOM_CONTENT_ENCODING_TYPE {
    CADESCOM_BASE64_TO_BINARY = 1,
    CADESCOM_STRING_TO_UCS2LE = 0,
}

export const enum CADESCOM_XML_SIGNATURE_TYPE {
    CADESCOM_XML_SIGNATURE_TYPE_ENVELOPED = 0,
    CADESCOM_XML_SIGNATURE_TYPE_ENVELOPING = 1,
    CADESCOM_XML_SIGNATURE_TYPE_TEMPLATE = 2,
}

export const enum CADESCOM_ENCRYPTION_ALGORITHM {
    CADESCOM_ENCRYPTION_ALGORITHM_RC2 = 0,
    CADESCOM_ENCRYPTION_ALGORITHM_RC4 = 1,
    CADESCOM_ENCRYPTION_ALGORITHM_DES = 2,
    CADESCOM_ENCRYPTION_ALGORITHM_3DES = 3,
    CADESCOM_ENCRYPTION_ALGORITHM_AES = 4,
    CADESCOM_ENCRYPTION_ALGORITHM_GOST_28147_89 = 25,
}

export const enum CADESCOM_HASH_ALGORITHM {
    CADESCOM_HASH_ALGORITHM_SHA1 = 0,
    CADESCOM_HASH_ALGORITHM_MD2 = 1,
    CADESCOM_HASH_ALGORITHM_MD4 = 2,
    CADESCOM_HASH_ALGORITHM_MD5 = 3,
    CADESCOM_HASH_ALGORITHM_SHA_256 = 4,
    CADESCOM_HASH_ALGORITHM_SHA_384 = 5,
    CADESCOM_HASH_ALGORITHM_SHA_512 = 6,
    CADESCOM_HASH_ALGORITHM_CP_GOST_3411 = 100,
    CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256 = 101,
    CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_512 = 102,
}

export const enum CADESCOM_ATTRIBUTE {
    CADESCOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME = 0,
    CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME = 1,
    CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_DESCRIPTION = 2,
    CADESCOM_ATTRIBUTE_OTHER = -1,
}

export const enum CADESCOM_DISPLAY_DATA {
    CADESCOM_DISPLAY_DATA_NONE = 0,
    CADESCOM_DISPLAY_DATA_CONTENT = 1,
    CADESCOM_DISPLAY_DATA_ATTRIBUTE = 2,
}

export const enum CADESCOM_InstallResponseRestrictionFlags {
    CADESCOM_AllowNone = 0,
    CADESCOM_AllowNoOutstandingRequest = 1,
    CADESCOM_AllowUntrustedCertificate = 2,
    CADESCOM_AllowUntrustedRoot = 4,
    CADESCOM_SkipInstallToStore = 0x10000000,
}

export const enum CADESCOM_ENCODING_TYPE {
    CAPICOM_ENCODE_ANY = -1,
    CAPICOM_ENCODE_BASE64 = 0,
    CAPICOM_ENCODE_BINARY = 1,
}
